import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { MapModels } from '@models/map.models';
import { createReducer, on } from '@ngrx/store';
import { MapActions } from '@states/map/map.action-types';
import { MapCustomObjectsActions } from '@states/map-custom-objects/map-custom-objects.action-types';

export interface MapState extends EntityState<MapModels.MapObject> {
  isLoading: boolean;
  imageUrl: string;
}

export const adapter: EntityAdapter<MapModels.MapObject> = createEntityAdapter<MapModels.MapObject>({
  selectId: (obj: MapModels.MapObject) => obj.a,
});

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();

const initialState: MapState = adapter.getInitialState({
  isLoading: false,
  imageUrl: null,
});

export const mapReducer = createReducer(
  initialState,
  on(MapActions.resetToInitialState, state => {
    return initialState;
  }),
  on(MapActions.setIsLoading, (state, { isLoading }) => {
    return {
      ...state,
      isLoading,
    };
  }),
  on(MapActions.getAllObjectsSuccess, (state, { objects }) => {
    return adapter.setAll(objects, {
      ...state
    });
  }),
  on(MapActions.getMarkerPictureSuccess, (state, { imageUrl }) => {
    return {
      ...state,
      imageUrl,
    };
  }),
  on(MapActions.resetImageUrl, (state) => {
    return {
      ...state,
      imageUrl: null,
    };
  }),
);
